import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { StudenteClasse } from 'src/app/models/registro/studente-classe';


@Component({
    selector: 'app-info-scarti-presenze',
    templateUrl: './info-scarti-presenze.component.html',
    styleUrls: ['./info-scarti-presenze.component.scss'],
    standalone: false
})
export class InfoScartiPresenzeComponent implements OnInit {

  @Input() studenti: StudenteClasse[];

  constructor(
    public modalCtrl: ModalController
    ) {
  }

  ngOnInit() {
  }

}
